import { useMemo } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { isAgentSelector } from '../../../../../../../selectors/userData/isAgentSelector';
import { selectRegionId } from '../../../../../../../selectors/village/selectRegionId';
import { selectVillageRoadsIds } from '../../../../../../../selectors/village/selectVillageRoads';
import { selectVillageStationsIds } from '../../../../../../../selectors/village/selectVillageStations';
import { getCalculatedParams, getRandomId, getJoinedUniqueIds } from '../utils';

import type { TPParams } from '../../../../../types';
import type { TAdfoxContextData } from '../../types';

type Params = TAdfoxContextData['params'];

export const PR_RANDOM = getRandomId();

export function useAdfoxParams(pParams: TPParams): Params {
  const regionId = useSelector(selectRegionId);
  const isAgent = useSelector(isAgentSelector);
  const selectedStations = useSelector(selectVillageStationsIds, shallowEqual);
  const selectedRoads = useSelector(selectVillageRoadsIds, shallowEqual);

  return useMemo((): Record<string, string> => {
    return {
      ...pParams,
      ...getCalculatedParams(),
      pr: PR_RANDOM,
      puid1: 'deal_type_sale',
      puid10: isAgent ? 'agent' : 'no_agent',
      puid2: 'offer_suburban',
      puid3: 'sale_type_first',
      puid5: `obl_id_${regionId}`,
      puid34: getJoinedUniqueIds(selectedStations),
      puid35: getJoinedUniqueIds(selectedRoads),
    };
  }, [isAgent, pParams, regionId, selectedRoads, selectedStations]);
}
